import { makePracticeWorkbook } from "./payroll-edit-workbook";

export const RERUN_SCENARIOS = {
  changed: {
    label: "Value changed",
    description:
      "You changed Alex’s bonus from $200 to $250. The new run calculates $300. Before review, your $250 edit is still in C2. Keep edit leaves $250 in C2. Discard restores $300 from the new run.",
  },
  applied: {
    label: "Edit still applied",
    description:
      "The new run still calculates a $200 bonus for Alex. Your $250 correction stays applied. There is no review action for this edit. Check C2 and the total in D2.",
  },
  matching: {
    label: "Pick row",
    description:
      "The new run has two rows for Alex Morgan, so the $250 edit is not applied yet. Select Pick row and compare the row details. In this sample, the correction belongs to the row with $1,200 base pay: row 2. Select Use this row to apply it.",
  },
  dropped: {
    label: "Row missing",
    description:
      "Alex is not in the new workbook, so the $250 bonus edit is not applied. The edit appears as Dropped in Manual edits. Check why the row is missing. If Alex should be included, correct the source data or contact Volca support, then run payroll again.",
  },
} as const;

export type RerunScenario = keyof typeof RERUN_SCENARIOS;
export type RerunDecision = "keep" | "discard" | "2:3" | "3:3" | null;

export const makeRerunWorkbook = (
  scenario: RerunScenario,
  decision: RerunDecision,
) => {
  const generatedBonus = scenario === "applied" ? 200 : 300;
  const edits: Record<string, string> = {};
  if (scenario === "changed" || scenario === "applied") {
    if (decision !== "discard") edits["2:3"] = "250";
  }
  if (scenario === "matching") {
    edits["3:1"] = "Alex Morgan";
    if (decision === "2:3" || decision === "3:3") edits[decision] = "250";
  }
  const sheet = makePracticeWorkbook(generatedBonus, edits);
  if (scenario !== "dropped") return sheet;
  const remaining = makePracticeWorkbook(generatedBonus, {
    "2:1": "Jamie Chen",
    "2:2": "1350",
    "2:3": "150",
    "3:1": "Sam Rivera",
    "3:2": "1100",
    "3:3": "100",
    "4:1": "Total",
    "4:2": "=SUM(B2:B3)",
    "4:3": "=SUM(C2:C3)",
    "4:4": "=SUM(D2:D3)",
  });
  const cells = remaining.cells
    .filter((cell) => cell.row < 5)
    .map((cell) => ({
      ...cell,
      format: { ...cell.format, bold: cell.row === 1 || cell.row === 4 },
    }));
  return { ...remaining, cells, cell_count: cells.length };
};
